import { supabase } from '@/lib/supabaseClient';

export type NotificationType = 'info' | 'success' | 'warning' | 'error';
export type NotificationCategory = 'lead' | 'payment' | 'signature' | 'addon' | 'delivery' | 'appointment' | 'system';

interface CreateNotificationParams {
  tenantId: string;
  type?: NotificationType;
  category?: NotificationCategory;
  title: string;
  message: string;
  entityType?: string;
  entityId?: string;
}

/**
 * Inserts a notification for the current authenticated user.
 * Fire-and-forget — does not throw.
 */
export async function createNotification({
  tenantId,
  type = 'info',
  category = 'system',
  title,
  message,
  entityType,
  entityId,
}: CreateNotificationParams): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    await supabase.from('notifications').insert({
      tenant_id: tenantId,
      user_id: user.id,
      type,
      category,
      title,
      message,
      entity_type: entityType ?? null,
      entity_id: entityId ?? null,
    });
  } catch {
    // Silently ignore — notifications are non-critical
  }
}
